import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const LOGO = "/logo-horsindex.png";

export default function NotFound() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div
      data-testid="page-not-found"
      className="bg-[#FAF9F7] text-[#181A1D] min-h-screen flex flex-col"
    >
      <header className="border-b border-[#E2DEDA] bg-[#FAF9F7]/95 backdrop-blur-md">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-6 flex items-center justify-between">
          <Link
            to="/"
            data-testid="not-found-logo"
            className="flex items-center gap-3 group"
          >
            <div className="inline-flex items-center justify-center overflow-hidden h-10 w-10 lg:h-11 lg:w-11">
              <img
                src={LOGO}
                alt="HorsIndex"
                className="h-10 w-10 lg:h-11 lg:w-11 object-contain transition-transform duration-500 group-hover:scale-105"
                style={{ transform: "scale(1.35)", transformOrigin: "center" }}
              />
            </div>
            <span className="font-serif text-xl text-[#181A1D] tracking-tight">
              HorsIndex
            </span>
          </Link>
          <span className="label-eyebrow text-[#666A70]">Erreur 404</span>
        </div>
      </header>

      <main className="flex-1 flex items-center">
        <div className="max-w-[1100px] w-full mx-auto px-6 lg:px-10 py-24 lg:py-32">
          <p className="label-eyebrow mb-6 text-[#666A70]">404</p>
          <h1
            data-testid="not-found-title"
            className="font-serif font-normal text-[#181A1D] text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-balance max-w-3xl"
          >
            Page <em className="italic">introuvable</em>.
          </h1>
          <p className="mt-10 max-w-xl text-lg text-[#52565C] font-normal leading-relaxed">
            La page demandée n'existe pas, n'est plus disponible ou n'est pas
            accessible publiquement.
          </p>
          <div className="mt-12 flex flex-wrap items-center gap-4">
            <Link
              to="/"
              className="btn-primary"
              data-testid="not-found-home-btn"
            >
              Retour à l'accueil
              <ArrowRight size={14} strokeWidth={1.5} />
            </Link>
          </div>
          <div className="mt-16 h-[2px] w-12 bg-[#E94B3C]" />
        </div>
      </main>

      <footer className="bg-[#181A1D] text-[#E2E8F0]">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-10">
          <p className="text-[11px] text-[#666A70]">
            © {new Date().getFullYear()} HorsIndex - horsindex.com
          </p>
        </div>
      </footer>
    </div>
  );
}
